module.exports = {
  'en': {
    'HRES3CUC1': {
      '0': '[HRES3CU] Follow up Employee"s Complaint',
      '10': '[HRES3CU] Follow up Employee"s Complaint',
      '20': 'Complaint No.',
      '30': 'Complain Date',
      '40': 'Complained By',
      '50': 'Department',
      '60': 'Type of Complaint',
      '70': 'Status'
    },
    'HRES3CUC2': {
      '0': 'Details of Action',
      '10': 'Details of Action',
      '20': 'Complaint No.',
      '30': 'Complained By',
      '40': 'Department',
      '50': 'Action Date',
      '60': 'Resp. By',
      '70': 'Name',
      '80': 'Details of Action',
      '90': 'Step of Processing'
    },
    'HRES3CUC3': {
      '0': 'Record Details of Action',
      '10': 'Details of Action',
      '20': 'Complaint No.',
      '30': 'Action Date',
      '40': 'Resp. By',
      '50': 'Details of Action',
      '60': 'Step Of Processing',
      '70': 'Result Of Action',
      '80': 'Follow up Date',
      '90': 'Settled Date',
      '100': 'Code Emp.',
      '110': 'Name Emp.',
      '120': 'List Of Employee',
      '130': 'Page'
    },
    'HRES3CUC4': {
      '0': 'Details fo Complaint',
      '10': 'Details fo Complaint',
      '20': 'Emp. Code',
      '30': 'Complaint No.',
      '40': 'Date',
      '50': 'Type of Complaint',
      '60': 'Description',
      '70': 'Status',
      '80': 'New',
      '90': 'During Process',
      '100': 'Settled',
      '110': 'Cancel',
      '120': 'Received By',
      '130': 'Ref. of Document 1.',
      '140': 'Ref. of Document 2.',
      '150': 'Ref. of Document 3.',
      '160': 'Other Detail'
    }
  },
  'th': {
    'HRES3CUC1': {
      '0': '[HRES3CU] บันทึกดำเนินการคำร้องเรียน',
      '10': '[HRES3CU] บันทึกดำเนินการคำร้องเรียน',
      '20': 'เลขที่คำร้องเรียน',
      '30': 'วันที่ยื่นคำร้อง',
      '40': 'ร้องเรียนโดย',
      '50': 'หน่วยงาน',
      '60': 'ประเภทคำร้องเรียน',
      '70': 'สถานะ'
    },
    'HRES3CUC2': {
      '0': 'รายละเอียดการดำเนินการ',
      '10': 'รายละเอียดการดำเนินการ',
      '20': 'เลขที่คำร้องเรียน',
      '30': 'ร้องเรียนโดย',
      '40': 'หน่วยงาน',
      '50': 'วันที่ดำเนินการ',
      '60': 'รหัสผู้ดำเนินการ',
      '70': 'ชื่อ',
      '80': 'รายละเอียดการดำเนินการ',
      '90': 'ขั้นตอนการดำเนินการ'
    },
    'HRES3CUC3': {
      '0': 'บันทึกรายละเอียดการดำเนินการ',
      '10': 'รายละเอียดการดำเนินการ',
      '20': 'เลขที่คำร้องเรียน',
      '30': 'วันที่ดำเนินการ',
      '40': 'รหัสผู้ดำเนินการ',
      '50': 'รายละเอียดการดำเนินการ',
      '60': 'ขั้นตอนการดำเนินการ',
      '70': 'ผลการดำเนินการ',
      '80': 'วันที่ตรวจสอบ',
      '90': 'วันที่ปิดคำร้องเรียน',
      '100': 'รหัสพนักงาน',
      '110': 'ชื่อ - นามสกุล',
      '120': 'รายชื่อพนักงาน',
      '130': 'จำนวนหน้า'
    },
    'HRES3CUC4': {
      '0': 'รายละเอียดคำร้องเรียน',
      '10': 'รายละเอียดคำร้องเรียน',
      '20': 'รหัสพนักงาน',
      '30': 'เลขที่คำร้องเรียน',
      '40': 'วันที่',
      '50': 'ประเภทคำร้องเรียน',
      '60': 'รายละเอียด',
      '70': 'สถานะ',
      '80': 'คำร้องใหม่',
      '90': 'ระหว่างดำเนินการ',
      '100': 'จบ',
      '110': 'ยกเลิก',
      '120': 'รับเรื่องโดย',
      '130': 'เอกสารอ้างอิง 1.',
      '140': 'เอกสารอ้างอิง 2.',
      '150': 'เอกสารอ้างอิงt 3.',
      '160': 'รายละเอียดอื่นๆ'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres3cu.js